export default __webpack_public_path__ + "67b908c204166334f6d344b7ed10ecbf.ttf";